<template>
  <div v-if="!$store.getters['user/getUserFields'].is_admin">
    Вы не администратор, авторизируйтесь как администратор!
  </div>

  <div v-else class="render">
    <div class="top">
      <h1>Статистика звонков</h1>
    </div>

    <div class="my_toolbar">
      <v-tabs v-model="tab" align-with-title class="tabs">
        <v-tabs-slider color="#4B5EFF" />
        <v-tab
          v-for="t in tabs"
          :key="t"
          class="item_tab"
          active-class="my_active_tab"
        >
          {{ t }}
        </v-tab>
      </v-tabs>
    </div>

    <div class="content_table">
      <v-tabs-items v-model="tab">
        <!-- 1) Исходящие -->
        <v-tab-item>
          <div class="stats-filters">
            <FilterReports
              page_type="stats_summary"
              :filter-config="filtersConfig.summary"
              :selects="selects"
              :callback="fetchSummary"
              :show-period="true"
              :hide-export="true"
              class="score-filters"
            />
          </div>

          <div class="kpi-cards">
            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-phone-outgoing</v-icon>
              </div>
              <div class="kpi-label">Звонков</div>
              <div class="kpi-value">{{ summary.calls }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              </div>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ summary.minutes }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              </div>
              <div class="kpi-label">Сумма</div>
              <div class="kpi-value">{{ fmtRub(summary.sum) }}</div>
            </div>
          </div>

          <div class="tables-block">
            <div class="table-box">
              <div class="table-box__header">
                <p>Статистика по аккаунтам за выбранный период</p>
                <v-btn
                  small
                  class="export-btn"
                  @click="exportAccountStatsToExcel"
                  :disabled="!tables.accounts.length"
                >
                  Экспорт в Excel
                </v-btn>
              </div>

              <Table
                :loading="loading.summary"
                :headers="headers.accounts"
                :data="tables.accounts"
                :perPage="10"
                :callback_refresh="fetchSummary"
                :hideselect="true"
                :key="accountsTableKey"
                :group-by-fields="['account', 'channel', 'operator']"
                @grouping-changed="handleGroupingChange"
                page_type="stats_accounts"
              />
            </div>
          </div>
        </v-tab-item>
        <!-- 4) Входящие -->
        <v-tab-item>
          <div class="stats-filters">
            <FilterReports
              page_type="stats_incoming"
              :filter-config="filtersConfig.incoming"
              :selects="selects"
              :callback="fetchIncoming"
              :show-period="true"
              :hide-export="true"
              class="score-filters"
            />
          </div>

          <!-- KPI входящих -->
          <div class="kpi-cards">
            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-phone-incoming</v-icon>
              </div>
              <div class="kpi-label">Звонков</div>
              <div class="kpi-value">{{ incomingSummary.calls }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-clock-outline</v-icon>
              </div>
              <div class="kpi-label">Минуты</div>
              <div class="kpi-value">{{ incomingSummary.minutes }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              </div>
              <div class="kpi-label">Сумма</div>
              <div class="kpi-value">{{ fmtRub(incomingSummary.sum) }}</div>
            </div>
          </div>

          <div class="tables-block">
            <div class="table-box">
              <div class="table-box__header">
                <p>Аналитика входящих вызовов</p>
                <v-btn
                  small
                  class="export-btn"
                  @click="exportIncomingToExcel"
                  :disabled="!tables.incoming.length"
                >
                  Экспорт в Excel
                </v-btn>
              </div>

              <Table
                :loading="loading.incoming"
                :headers="headers.incoming"
                :data="tables.incoming"
                :perPage="20"
                :callback_refresh="fetchIncoming"
                :hideselect="true"
                page_type="stats_incoming"
              />
            </div>
          </div>
        </v-tab-item>

        <!-- 5) СКОР -->
        <v-tab-item>
          <div class="stats-filters">
            <FilterReports
              page_type="stats_score"
              :filter-config="filtersConfig.score"
              :selects="selects"
              :callback="fetchScore"
              :show-period="true"
              :hide-export="true"
              class="score-filters"
            />
          </div>
          <div class="kpi-cards">
            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-database-import</v-icon>
              </div>
              <div class="kpi-label">Загружено номеров</div>
              <div class="kpi-value">{{ scoreSummary.loaded }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF"
                  >mdi-check-decagram-outline</v-icon
                >
              </div>
              <div class="kpi-label">Оценено номеров</div>
              <div class="kpi-value">{{ scoreSummary.scored }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-icon">
                <v-icon large color="#4B5EFF">mdi-currency-rub</v-icon>
              </div>
              <div class="kpi-label">Сумма</div>
              <div class="kpi-value">{{ fmtRub(scoreSummary.sum) }}</div>
            </div>
          </div>

          <div class="tables-block">
            <div class="table-box">
              <div class="table-box__header">
                <p>Расход за СКОР</p>
                <v-btn
                  small
                  class="export-btn"
                  @click="exportScoreToExcel"
                  :disabled="!tables.score.length"
                >
                  Экспорт в Excel
                </v-btn>
              </div>

              <Table
                :loading="loading.score"
                :headers="headers.score"
                :data="tables.score"
                :perPage="20"
                :callback_refresh="fetchScore"
                :hideselect="true"
                page_type="stats_score"
              />
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <DialingAnalytics />
        </v-tab-item>

        <!-- 6) Звонки пользователя -->
        <v-tab-item>
          <div class="stats-filters">
            <FilterReports
              page_type="stats_user_calls"
              :filter-config="filtersConfig.calls"
              :selects="selects"
              :callback="fetchUserCalls"
              :show-period="true"
              @export="exportUserCallsToExcel"
              class="score-filters"
            />
          </div>

          <Table
            :loading="loading.userCalls"
            :headers="headers.userCalls"
            :data="tables.userCalls"
            :perPage="50"
            :callback_refresh="fetchUserCalls"
            :hideselect="true"
            :no-data-text="
              userCallsNeedAccount ? 'Выберите аккаунт' : 'Нет записей'
            "
            page_type="stats_user_calls"
          />
        </v-tab-item>

        <!-- 7) Верификация -->
        <v-tab-item>
          <div class="stats-filters">
            <FilterReports
              page_type="verification_calls"
              :filter-config="[]"
              :selects="{}"
              :callback="fetchVerificationStats"
              :show-period="true"
              :hide-export="true"
              class="score-filters"
            />
          </div>

          <div class="kpi-cards">
            <div class="kpi-card">
              <div class="kpi-label">Всего запросов</div>
              <div class="kpi-value">{{ verificationStats.total }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-label">Успешных</div>
              <div class="kpi-value">{{ verificationStats.success }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-label">Неуспешных</div>
              <div class="kpi-value">{{ verificationStats.failed }}</div>
            </div>

            <div class="kpi-card">
              <div class="kpi-label">Сумма расходов</div>
              <div class="kpi-value">
                {{ fmtRub(verificationStats.total_cost) }}
              </div>
            </div>
          </div>

          <div class="tables-block">
            <div class="table-box">
              <div class="table-box__header">
                <p>Разрез по пользователям</p>
                <v-btn
                  small
                  class="export-btn"
                  @click="exportVerificationToExcel"
                  :disabled="!verificationUsers.length"
                >
                  Экспорт в Excel
                </v-btn>
              </div>

              <Table
                :headers="verificationHeaders"
                :data="verificationUsers"
                :perPage="20"
                :callback_refresh="fetchVerificationStats"
                :hideselect="true"
                :loading="loading.verification"
              />
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Table from '@/components/Table/DataTable.vue';
import FilterReports from '@/components/Filter/ReportsFilter.vue';
import DialingAnalytics from '@/components/Statistics/DialingAnalytics.vue';

export default {
  name: 'StatisticsTable',
  components: { Table, FilterReports, DialingAnalytics },

  data() {
    return {
      tab: 0,
      currentGrouping: [],
      groupedAccountsData: [],
      userCallsNeedAccount: false,
      accountsTableKey: 0,
      tabs: [
        'Аналитика исходящих',
        'Аналитика входящих',
        'Расход за СКОР',
        'Аналитика дозвона',
        'Звонки пользователя',
        'Звонки с кодом подтверждения',
      ],

      loading: {
        summary: false,
        userCalls: false,
        incoming: false,
        score: false,
        verification: false,
      },

      selects: {
        accounts: [],
        channels: [],
      },

      filtersConfig: {
        summary: [
          {
            type: 'select',
            field: 'account',
            label: 'Аккаунт',
            items: 'accounts',
            multiple: true,
          },
          {
            type: 'select',
            field: 'channel',
            label: 'Транк',
            items: 'channels',
          },
        ],
        calls: [
          { type: 'search', field: 'phoneB', label: 'Телефон B' },
          {
            type: 'select',
            field: 'account',
            label: 'Аккаунт',
            items: 'accounts',
            multiple: true,
          },
          {
            type: 'select',
            field: 'channel',
            label: 'Транк',
            items: 'channels',
          },
        ],
        incoming: [
          {
            type: 'select',
            field: 'user',
            label: 'Пользователь',
            items: 'accounts',
            multiple: true,
          },
        ],
        score: [
          {
            type: 'select',
            field: 'user',
            label: 'Пользователь',
            items: 'accounts',
            multiple: true,
          },
        ],
      },

      summary: { calls: 0, minutes: 0, sum: 0 },
      incomingSummary: { calls: 0, minutes: 0, sum: 0 },
      scoreSummary: { loaded: 0, scored: 0, sum: 0 },

      verificationStats: { total: 0, success: 0, failed: 0, total_cost: 0 },
      verificationUsers: [],

      tables: {
        accounts: [],
        channels: [],
        incoming: [],
        score: [],
        operators: [],
        userCalls: [],
      },

      headers: {
        accounts: [
          { text: 'Аккаунт', value: 'account' },
          { text: 'Транк', value: 'channel' },
          { text: 'Оператор B-номера', value: 'operator' },
          { text: 'Кол-во вызовов', value: 'totalCalls' },
          { text: 'Секунды', value: 'totalSeconds' },
          { text: 'Минуты', value: 'totalMinutes' },
          { text: 'Стоимость минуты', value: 'minutesPrice' },
          { text: 'Стоимость инициации', value: 'totalInitPrice' },
          { text: 'Стоимость (итого)', value: 'totalPrice' },
          { text: 'Цена инициации', value: 'initiationPrice' },
        ],

        channels: [
          { text: 'Транк', value: 'channel' },
          { text: 'Общее количество вызовов', value: 'totalRecords' },
          { text: 'Технически отвечено', value: 'answered' },
          { text: 'Реально отвечено', value: 'realAnswered' },
          { text: 'Технический процент дозвона', value: 'answerRate' },
          { text: 'Реальный процент дозвона', value: 'realAnswerRate' },
          { text: 'Кол-во секунд', value: 'totalSeconds' },
        ],

        operators: [
          { text: 'Оператор B-номера', value: 'operator' },
          { text: 'Общее количество вызовов', value: 'totalRecords' },
          { text: 'Технически отвечено', value: 'answered' },
          { text: 'Реально отвечено', value: 'realAnswered' },
          { text: 'Технический процент дозвона', value: 'answerRate' },
          { text: 'Реальный процент дозвона', value: 'realAnswerRate' },
          { text: 'Кол-во секунд', value: 'totalSeconds' },
        ],

        // ВХОДЯЩИЕ: добавили calls + minutes
        incoming: [
          { text: 'Пользователь', value: 'user' },
          { text: 'Кол-во звонков', value: 'totalCalls' },
          { text: 'Минуты', value: 'totalMinutes' },
          { text: 'Сумма', value: 'sum' },
        ],

        score: [
          { text: 'Пользователь', value: 'user' },
          { text: 'Расход за СКОР', value: 'sum' },
          { text: 'Дата операции', value: 'score_date' },
        ],

        userCalls: [
          { text: 'Пользователь', value: 'user' },
          { text: 'Дата звонка', value: 'date' },
          { text: 'phoneB', value: 'phoneB' },
          { text: 'Транк', value: 'channel' },
          { text: 'Продолжительность (сек)', value: 'duration' },
          { text: 'amdCause', value: 'amdCause' },
          { text: 'Ссылка на запись', value: 'record' },
          { text: 'call_name', value: 'callName' },
          { text: 'amdstatus', value: 'amdStatus' },
          { text: 'ami_error', value: 'amiError' },
        ],
      },

      verificationHeaders: [
        { text: 'id', value: 'user_id' },
        { text: 'Пользователь', value: 'user_name' },
        { text: 'Всего', value: 'total' },
        { text: 'Успешных', value: 'success' },
        { text: 'Неуспешных', value: 'failed' },
        { text: 'Стоимость', value: 'total_cost' },
      ],
    };
  },

  methods: {
    parseScoreService(service = '') {
      const text = String(service || '').trim();

      let match = text.match(/оценено\s+(\d+)\s+из\s+(\d+)/i);
      if (match) {
        return {
          scored: Number(match[1] || 0),
          loaded: Number(match[2] || 0),
        };
      }

      match = text.match(/\((\d+)\)/);
      if (match) {
        return {
          scored: Number(match[1] || 0),
          loaded: 0,
        };
      }

      return {
        scored: 0,
        loaded: 0,
      };
    },
    handleGroupingChange(payload) {
      this.currentGrouping = payload.fields;
      if (!payload.fields.length) {
        this.groupedAccountsData = [];
      } else {
        this.groupedAccountsData = payload.data;
      }
    },
    resetGrouping() {
      this.currentGrouping = [];
      this.groupedAccountsData = [];
    },
    apiPost(url, payload) {
      return new Promise((resolve) => {
        this.$http.post(url, payload, (r) => resolve(r));
      });
    },

    pickId(v) {
      return v && typeof v === 'object'
        ? v.id ?? v.value ?? v._id ?? v.name ?? v.label ?? ''
        : v;
    },

    pickIds(v) {
      if (!v) return [];
      if (Array.isArray(v)) return v.map(this.pickId).filter(Boolean);
      const one = this.pickId(v);
      return one ? [one] : [];
    },

    normalizePeriod(filters = {}) {
      const f = { ...filters };

      if (!f.startDate && !f.endDate) {
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const today = `${yyyy}-${mm}-${dd}`;

        f.startDate = today;
        f.endDate = today;
        if (!f.startTime) f.startTime = '00:00';
        if (!f.endTime) f.endTime = '23:59';
      }

      if (!f.startTime) f.startTime = '00:00';
      if (!f.endTime) f.endTime = '23:59';
      return f;
    },

    combineDateTime(date, time) {
      if (!date) return null;
      return `${date}T${time || '00:00'}`;
    },

    fmtRub(v) {
      const n = Number(v || 0);
      try {
        return new Intl.NumberFormat('ru-RU').format(n) + ' ₽';
      } catch {
        return n + ' ₽';
      }
    },

    fmtPercent(v) {
      const num = Number(v);
      if (!isFinite(num)) return '0.00%';
      return num.toFixed(2) + '%';
    },

    fmtDateTime(iso) {
      if (!iso) return '—';
      const safe = typeof iso === 'string' ? iso.replace(' ', 'T') : iso;
      const d = new Date(safe);
      if (isNaN(d)) return '—';
      const p = (n) => String(n).padStart(2, '0');
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(
        d.getHours(),
      )}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },

    // =========================
    // ИСХОДЯЩИЕ (summary)
    // =========================
    async fetchSummary(filters = {}) {
      this.loading.summary = true;
      this.accountsTableKey++;
      this.currentGrouping = [];
      this.groupedAccountsData = [];
      this.resetGrouping();
      try {
        const f = this.normalizePeriod(filters);

        const basePayload = {
          startDate: this.combineDateTime(f.startDate, f.startTime),
          endDate: this.combineDateTime(f.endDate, f.endTime),
        };

        const accArr = this.pickIds(f.account);
        const chArr = this.pickIds(f.channel);

        const hasAccount = accArr.length > 0;
        const hasChannel = chArr.length > 0;

        let url = '/statistics/date';
        const payload = { ...basePayload };

        if (hasAccount) {
          url = '/statistics/account';
          payload.account = accArr;
          payload.channel = hasChannel ? chArr : [];
        } else if (hasChannel) {
          url = '/statistics/channel';
          payload.channel = chArr;
          payload.account = [];
        }

        const resp = await this.apiPost(url, payload);

        if (!resp || resp === 'error') {
          this.summary = { calls: 0, minutes: 0, sum: 0 };
          this.tables.accounts = [];
          this.tables.channels = [];
          this.tables.operators = [];
          return;
        }

        let accountsRaw = [];
        let channelsRaw = [];
        let operatorsRaw = [];
        let summaryRow = {};

        if (url === '/statistics/date') {
          summaryRow =
            Array.isArray(resp.summary) && resp.summary[0]
              ? resp.summary[0]
              : {};
          channelsRaw = Array.isArray(resp.channelAnalytics)
            ? resp.channelAnalytics
            : [];
          operatorsRaw = Array.isArray(resp.operatorAnalytics)
            ? resp.operatorAnalytics
            : [];
          accountsRaw = Array.isArray(resp.userChannelDetails)
            ? resp.userChannelDetails
            : [];

          if (!this.selects.channels.length) {
            const chSet = new Set(
              channelsRaw.map((x) => x.channel).filter(Boolean),
            );
            this.selects.channels = Array.from(chSet).map((x) => ({
              id: x,
              name: x,
            }));
          }
          if (!this.selects.accounts.length) {
            const accSet = new Set(
              accountsRaw.map((x) => x.user).filter(Boolean),
            );
            this.selects.accounts = Array.from(accSet).map((x) => ({
              id: x,
              name: x,
            }));
          }
        } else if (url === '/statistics/account') {
          accountsRaw = Array.isArray(resp.result) ? resp.result : [];
          channelsRaw = Array.isArray(resp.result1) ? resp.result1 : [];
          operatorsRaw = Array.isArray(resp.result3) ? resp.result3 : [];
          summaryRow =
            Array.isArray(resp.result2) && resp.result2[0]
              ? resp.result2[0]
              : {};
        } else if (url === '/statistics/channel') {
          channelsRaw = Array.isArray(resp.result) ? resp.result : [];
          accountsRaw = Array.isArray(resp.result1) ? resp.result1 : [];
          operatorsRaw = Array.isArray(resp.result3) ? resp.result3 : [];
          summaryRow =
            Array.isArray(resp.result2) && resp.result2[0]
              ? resp.result2[0]
              : {};
        }

        this.tables.accounts = accountsRaw.map((x) => ({
          id: x.id || `${x.user || ''}-${x.channel || ''}-${x.operator || ''}`,
          account: x.user,
          channel: x.channel,
          operator: x.operator,
          totalCalls: Number(x.total_calls || 0),
          totalSeconds: Number(x.total_seconds || 0),
          totalMinutes: Number(x.totalMinutes || 0),
          minutesPrice: Number(x.minutes_price).toFixed(2),
          totalInitPrice: Number(x.total_init_price || 0).toFixed(2),
          totalPrice: Number(x.total_price).toFixed(2),
          initiationPrice: (Number(x.total_calls || 0)
            ? Number(x.total_init_price || 0) / Number(x.total_calls || 0)
            : 0
          ).toFixed(2),
        }));

        this.tables.channels = channelsRaw.map((x) => ({
          id: x.channel || x.id || Math.random().toString(36).slice(2),
          channel: x.channel,
          totalRecords: Number(x.total_records || 0),
          answered: Number(x.records_with_seconds_greater_than_1 || 0),
          realAnswered: Number(x.real_answered || 0),
          answerRate: this.fmtPercent(x.percentage_with_seconds_greater_than_1),
          realAnswerRate: this.fmtPercent(x.real_answer_rate),
          totalSeconds: Number(x.total_seconds || 0),
        }));

        this.tables.operators = operatorsRaw.map((x) => ({
          id: x.operator || x.id || Math.random().toString(36).slice(2),
          operator: x.operator,
          totalRecords: Number(x.total_records || 0),
          answered: Number(x.records_with_seconds_greater_than_1 || 0),
          realAnswered: Number(x.real_answered || 0),
          answerRate: this.fmtPercent(x.percentage_with_seconds_greater_than_1),
          realAnswerRate: this.fmtPercent(x.real_answer_rate),
          totalSeconds: Number(x.total_seconds || 0),
        }));

        // KPI: если бэк отдаёт totalCalls — берём его,
        // иначе подстрахуемся и посчитаем из accounts
        const callsFromBackend = Number(
          summaryRow?.totalCalls || summaryRow?.total_calls || 0,
        );
        const callsFallback = this.tables.accounts.reduce(
          (a, r) => a + (r.totalCalls || 0),
          0,
        );

        this.summary = {
          calls: callsFromBackend || callsFallback || 0,
          minutes: Number(summaryRow?.totalMinutes || 0),
          sum: Number(summaryRow?.totalPrice || 0),
          totalInitCost: Number(summaryRow?.totalInitPrice || 0),
          initiationCount: callsFromBackend || callsFallback || 0,
        };
      } finally {
        this.loading.summary = false;
      }
    },

    // =========================
    // ВХОДЯЩИЕ
    // =========================
    async fetchIncoming(filters = {}) {
      this.loading.incoming = true;
      try {
        const f = this.normalizePeriod(filters);

        const payload = {
          startDate: this.combineDateTime(f.startDate, f.startTime),
          endDate: this.combineDateTime(f.endDate, f.endTime),
        };

        const users = this.pickIds(f.user);
        if (users.length) payload.user = users;

        const resp = await this.apiPost('/statistics/incoming', payload);
        const rows = Array.isArray(resp) ? resp : [];

        this.tables.incoming = rows.map((x) => ({
          id: x.user || Math.random().toString(36).slice(2),
          user: x.user,
          totalCalls: Number(x.totalCalls || x.total_calls || 0),
          totalMinutes: Number(x.totalMinutes || x.total_minutes || 0),
          sum: Number(x.sum || 0),
        }));

        this.incomingSummary = {
          calls: this.tables.incoming.reduce(
            (a, r) => a + (r.totalCalls || 0),
            0,
          ),
          minutes: this.tables.incoming.reduce(
            (a, r) => a + (r.totalMinutes || 0),
            0,
          ),
          sum: this.tables.incoming.reduce((a, r) => a + (r.sum || 0), 0),
        };
      } finally {
        this.loading.incoming = false;
      }
    },

    // =========================
    // СКОР
    // =========================
    async fetchScore(filters = {}) {
      this.loading.score = true;
      try {
        const f = this.normalizePeriod(filters);

        const payload = {
          startDate: this.combineDateTime(f.startDate, f.startTime),
          endDate: this.combineDateTime(f.endDate, f.endTime),
        };

        const users = this.pickIds(f.user);
        if (users.length) payload.user = users;

        const resp = await this.apiPost('/statistics/score', payload);
        const rows = Array.isArray(resp) ? resp : [];

        let totalLoaded = 0;
        let totalScored = 0;
        let totalSum = 0;

        this.tables.score = rows.map((x) => {
          const parsed = this.parseScoreService(x.service);

          totalLoaded += parsed.loaded;
          totalScored += parsed.scored;
          totalSum += Number(x.price || 0);

          return {
            id:
              x.id ||
              `${x.user || ''}-${x.score_date || ''}-${x.service || ''}`,
            user: x.user,
            loadedCount: parsed.loaded,
            scoredCount: parsed.scored,
            sum: Number(x.price || 0),
            score_date: this.fmtDateTime(x.score_date),
          };
        });

        this.scoreSummary = {
          loaded: totalLoaded,
          scored: totalScored,
          sum: totalSum,
        };
      } finally {
        this.loading.score = false;
      }
    },

    // =========================
    // ЗВОНКИ ПОЛЬЗОВАТЕЛЯ
    // =========================
    async fetchUserCalls(filters = {}) {
      const f = this.normalizePeriod(filters);
      const phone = (f.phoneB || '').trim();

      const accArr = this.pickIds(f.account);
      const chArr = this.pickIds(f.channel);

      if (!accArr.length) {
        this.loading.userCalls = true;
        try {
          const resp = await this.apiPost('/statistics/phoneBFull', {
            startDate: this.combineDateTime(f.startDate, f.startTime),
            endDate: this.combineDateTime(f.endDate, f.endTime),
            onlyUsers: true,
          });

          const rows = Array.isArray(resp) ? resp : [];

          this.selects.accounts = rows
            .map((x) => x.user)
            .filter(Boolean)
            .map((x) => ({ id: x, name: x }));
          this.userCallsNeedAccount = true;
          this.tables.userCalls = [];

          return;
        } finally {
          this.loading.userCalls = false;
        }
      }
      this.userCallsNeedAccount = false;
      this.loading.userCalls = true;
      try {
        const payload = {
          phoneB: phone,
          startDate: this.combineDateTime(f.startDate, f.startTime),
          endDate: this.combineDateTime(f.endDate, f.endTime),
        };

        if (accArr.length) payload.account = accArr;
        if (chArr.length) payload.channel = chArr;

        const resp = await this.apiPost('/statistics/phoneBFull', payload);
        const rows = Array.isArray(resp) ? resp : [];
        const chSet = new Set(rows.map((x) => x.channel).filter(Boolean));
        this.selects.channels = Array.from(chSet).map((x) => ({
          id: x,
          name: x,
        }));

        // const accSet = new Set(rows.map(x => x.user).filter(Boolean))
        // this.selects.accounts = Array.from(accSet).map(x => ({ id: x, name: x }))

        this.tables.userCalls = rows.map((x) => ({
          id:
            x.id ||
            `${x.user || ''}-${x.created_at || ''}-${x.phoneB || ''}-${
              x.channel || ''
            }-${x.seconds || 0}`,
          user: x.user,
          date: this.fmtDateTime(x.created_at),
          phoneB: x.phoneB,
          channel: x.channel,
          duration: Number(x.seconds || 0),
          amdCause: x.asterisk_box,
          record: x.record,
          callName: x.call_name,
          amdStatus: x.status,
          amiError: x.text,
        }));
      } finally {
        this.loading.userCalls = false;
      }
    },

    // =========================
    // ВЕРИФИКАЦИЯ
    // =========================
    async fetchVerificationStats(filters = {}) {
      this.loading.verification = true;
      try {
        const f = this.normalizePeriod(filters);

        const payload = {
          from: this.combineDateTime(f.startDate, f.startTime),
          to: this.combineDateTime(f.endDate, f.endTime),
        };

        const resp = await this.apiPost(
          '/v1/verification-calls/stats',
          payload,
        );

        if (!resp || !resp.ok) {
          this.verificationStats = {
            total: 0,
            success: 0,
            failed: 0,
            total_cost: 0,
          };
          this.verificationUsers = [];
          return;
        }

        this.verificationStats = {
          total: resp.total,
          success: resp.success,
          failed: resp.failed,
          total_cost: resp.total_cost,
        };

        this.verificationUsers = resp.by_user || [];
      } finally {
        this.loading.verification = false;
      }
    },

    // =========================
    // EXPORTS
    // =========================
    exportAccountStatsToExcel() {
      const dataToExport = this.groupedAccountsData.length
        ? this.groupedAccountsData
        : this.tables.accounts;

      if (!dataToExport.length) return;

      const round2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

      // какие поля показывать как группировки (и как их назвать в Excel)
      const groupLabel = {
        account: 'Аккаунт',
        channel: 'Транк',
        operator: 'Оператор B-номера',
      };

      // если группировки нет — показываем все 3 как раньше
      const groupFields = this.currentGrouping.length
        ? this.currentGrouping
        : ['account', 'channel', 'operator'];

      const data = dataToExport.map((x) => {
        const row = {};

        // добавляем только выбранные группировки
        groupFields.forEach((f) => {
          row[groupLabel[f]] = x[f] || '';
        });

        // метрики всегда
        row['Кол-во вызовов'] = Number(x.totalCalls || 0);
        row['Секунды'] = Number(x.totalSeconds || 0);
        row['Минуты'] = Number(x.totalMinutes || 0);
        row['Стоимость минуты'] = round2(x.minutesPrice);
        row['Стоимость инициации'] = round2(x.totalInitPrice);
        row['Стоимость (итого)'] = round2(x.totalPrice);
        row['Цена инициации'] = round2(x.initiationPrice);

        return row;
      });

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Статистика по аккаунтам');

      const fileName = this.currentGrouping.length
        ? `account_statistics_grouped_${this.currentGrouping.join('_')}.xlsx`
        : 'account_statistics.xlsx';

      XLSX.writeFile(wb, fileName);
    },

    exportIncomingToExcel() {
      if (!this.tables.incoming.length) return;
      const data = this.tables.incoming.map((x) => ({
        Пользователь: x.user,
        'Кол-во звонков': x.totalCalls,
        Минуты: x.totalMinutes,
        Сумма: x.sum,
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Аналитика входящих');
      XLSX.writeFile(wb, 'incoming_analytics.xlsx');
    },

    exportScoreToExcel() {
      if (!this.tables.score.length) return;

      const data = [
        {
          Пользователь: 'ИТОГО',
          'Загружено номеров': this.scoreSummary.loaded,
          'Оценено номеров': this.scoreSummary.scored,
          Сумма: this.scoreSummary.sum,
          'Дата операции': '',
        },
        {},
        ...this.tables.score.map((x) => ({
          Пользователь: x.user,
          'Загружено номеров': x.loadedCount,
          'Оценено номеров': x.scoredCount,
          Сумма: x.sum,
          'Дата операции': x.score_date,
        })),
      ];

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Расход за СКОР');
      XLSX.writeFile(wb, 'score_expenses.xlsx');
    },

    exportChannelAnalyticsToExcel() {
      if (!this.tables.channels.length) return;
      const data = this.tables.channels.map((x) => ({
        Транк: x.channel,
        'Общее количество вызовов': x.totalRecords,
        'Технически отвечено': x.answered,
        'Реально отвечено': x.realAnswered,
        'Технический процент дозвона': x.answerRate,
        'Реальный процент дозвона': x.realAnswerRate,
        'Кол-во секунд': x.totalSeconds,
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Аналитика транков');
      XLSX.writeFile(wb, 'channel_analytics.xlsx');
    },

    exportOperatorAnalyticsToExcel() {
      if (!this.tables.operators.length) return;
      const data = this.tables.operators.map((x) => ({
        'Оператор B-номера': x.operator,
        'Общее количество вызовов': x.totalRecords,
        'Технически отвечено': x.answered,
        'Реально отвечено': x.realAnswered,
        'Технический процент дозвона': x.answerRate,
        'Реальный процент дозвона': x.realAnswerRate,
        'Кол-во секунд': x.totalSeconds,
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Аналитика операторов B');
      XLSX.writeFile(wb, 'operator_analytics.xlsx');
    },

    exportVerificationToExcel() {
      if (!this.verificationUsers.length) return;
      const data = this.verificationUsers.map((u) => ({
        'ID пользователя': u.user_id,
        Пользователь: u.user_name,
        'Всего запросов': u.total,
        Успешных: u.success,
        Неуспешных: u.failed,
        'Стоимость всего': u.total_cost,
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Звонки с кодом');
      XLSX.writeFile(wb, 'verification_calls_summary.xlsx');
    },

    async exportUserCallsToExcel(filters = {}) {
      this.loading.userCalls = true;
      const f = this.normalizePeriod(filters);
      const phone = (f.phoneB || '').trim();
      // if (!phone) return

      const payload = {
        phoneB: phone,
        startDate: this.combineDateTime(f.startDate, f.startTime),
        endDate: this.combineDateTime(f.endDate, f.endTime),
      };

      const accArr = this.pickIds(f.account);
      const chArr = this.pickIds(f.channel);
      if (accArr.length) payload.account = accArr;
      if (chArr.length) payload.channel = chArr;

      const resp = await this.apiPost('/statistics/phoneBFull', payload);
      const rows = Array.isArray(resp) ? resp : [];

      const data = rows.map((x) => ({
        Пользователь: x.user,
        'Дата звонка': this.fmtDateTime(x.created_at),
        phoneB: x.phoneB,
        Транк: x.channel,
        'Продолжительность вызова': Number(x.seconds || 0),
        amdCause: x.asterisk_box,
        'Ссылка на запись': x.record,
        call_name: x.call_name,
        amdstatus: x.status,
        ami_error: x.text,
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Звонки пользователя');
      XLSX.writeFile(wb, 'user_calls.xlsx');
      this.loading.userCalls = false;
    },
  },
};
</script>

<style scoped>
/* твои стили оставил как есть */
.score-filters ::v-deep .input_custom--select .v-input__slot {
  width: 220px !important;
  min-width: 250px !important;
  max-width: 250px !important;
  min-height: 40px !important;
  max-height: 40px !important;
}
.content_table {
  margin-top: 24px;
}
.my_toolbar {
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
}
.tabs {
  flex: 1;
}
.item_tab {
  text-transform: none !important;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #808185;
}
.my_active_tab {
  color: #2b2d33;
}

.kpi-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 24px;
}
.kpi-card {
  flex: 1 1 200px;
  background: #ffffff;
  border-radius: 10px;
  padding: 16px 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
}
.kpi-icon {
  margin-right: 12px;
}
.kpi-label {
  font-size: 13px;
  color: #6f7075;
}
.kpi-value {
  margin-left: auto;
  font-weight: 700;
  font-size: 20px;
  color: #2b2d33;
}

.tables-block {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.table-box {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px 16px 24px 16px;
}
.table-box__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.table-box__header p {
  margin: 0;
  font-weight: 500;
}

.export-btn {
  background: #28a745 !important;
  color: #ffffff !important;
  text-transform: none;
  border-radius: 6px !important;
  font-size: 13px;
  padding: 6px 12px;
}

.stats-filters ::v-deep .v-select.v-select--chips .v-input__slot,
.stats-filters ::v-deep .v-combobox.v-select--chips .v-input__slot {
  min-height: 40px;
  max-height: 40px;
  overflow: hidden;
}
.stats-filters ::v-deep .v-select.v-select--chips,
.stats-filters ::v-deep .v-combobox.v-select--chips {
  max-width: 180px;
}
.stats-filters ::v-deep .v-select.v-select--chips .v-select__selections,
.stats-filters ::v-deep .v-combobox.v-select--chips .v-select__selections {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.stats-filters ::v-deep .v-select.v-select--chips .v-chip,
.stats-filters ::v-deep .v-combobox.v-select--chips .v-chip {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 22px;
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>
